import { render, staticRenderFns } from "./GColorpicker.vue?vue&type=template&id=16d529f0&"
import script from "./GColorpicker.vue?vue&type=script&lang=ts&"
export * from "./GColorpicker.vue?vue&type=script&lang=ts&"
import style0 from "./GColorpicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports